import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';
import { instanceOf } from 'prop-types';
import { Cookies, withCookies } from 'react-cookie';
import AppNavbar from '../AppNavbar.js';

class EditUser extends Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    emptyItem = {
        firstName: '',
        lastName: '',
        userName: '',
        userEmail: '',
        userPhoneNumber: ''
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {
            item: this.emptyItem,
            csrfToken: cookies.get('XSRF-TOKEN')
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        console.log('CDM');
        if (this.props.match.params.id !== 'new') {
            try {
                const group = await (await fetch(`/alumsum/user/${this.props.match.params.id}`, {credentials: 'include'})).json();
                this.setState({item: group});
                console.log('CDMTry');
            } catch (error) {
                this.props.history.push('/');
                console.log('CDMcatch');
            }
        }
        console.log(this.props.match);
    }


    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = {...this.state.item};
        item[name] = value;
        this.setState({item});
        console.log('handlechange');
    }

    async handleSubmit(event) {
        event.preventDefault();
        const {item, csrfToken} = this.state;
        console.log(item);
        console.log('handlesubmit');

        await fetch('/alumsum/user' + (item.id ? '/' + item.id : ''), {
            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'X-XSRF-TOKEN': csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
            credentials: 'include'
        });
        this.props.history.push('/alumsum/onboardingpersonal');
        console.log('fetchfinished');
    }

    render() {
        const {item} = this.state;
        item.enabled = true;
        const title = <h2>{item.id ? 'Edit User' : 'Add User'}</h2>;

        return (
            <div>
            <AppNavbar/>
            <Container>
                {title}
                <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Label for="name">First Name</Label>
                        <Input type="text" name="firstName" id="name" value={item.firstName || ''}
                               onChange={this.handleChange} autoComplete="name"/>
                    </FormGroup>
                    <FormGroup>
                        <Label for="last">Last Name</Label>
                        <Input type="text" name="lastName" id="last" value={item.lastName || ''}
                               onChange={this.handleChange} autoComplete="address-level1"/>
                    </FormGroup>
                    <FormGroup>
                        <Label for="uname">User Name</Label>
                        <Input type="text" name="userName" id="uname" value={item.userName || ''}
                               onChange={this.handleChange} autoComplete="address-level1"/>
                    </FormGroup>
                    <div className="row">
                        <FormGroup className="col-md-4 mb-3">
                            <Label for="emai">Email Address</Label>
                            <Input type="email" name="userEmail" id="email" value={item.userEmail || ''}
                                   onChange={this.handleChange} autoComplete="address-level1"/>
                        </FormGroup>
                        <FormGroup className="col-md-3 mb-3">
                            <Label for="phone">Phone Number</Label>
                            <Input type="text" name="userPhoneNumber" id="phone" value={item.userPhoneNumber || ''}
                                   onChange={this.handleChange} autoComplete="address-level1"/>
                        </FormGroup>
                    </div>
                    <FormGroup>
                        <Button color="primary" type="submit">Save</Button>{' '}
                        <Button color="secondary" tag={Link} to="/alumsum/users">Cancel</Button>
                    </FormGroup>
                </Form>
            </Container>
        </div>
        )
    }
}

export default withCookies(withRouter(EditUser));